import React from "react";

const DeleteConfirmation = ({ item, onConfirm, onCancel }) => {
  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true">
      <div className="modal-window">
        <div className="modal-header">
          <div className="modal-icon modal-icon--danger" aria-hidden="true">
            !
          </div>
          <div>
            <h3 className="modal-title">Poistetaanko?</h3>
            <p className="modal-description">
              Haluatko varmasti poistaa tämän: <strong style={{fontWeight: "bold"}}>{item}</strong>?
            </p>
          </div>
        </div>

        <div className="modal-actions modal-actions--end">
          <button className="btn btn-ghost" onClick={onCancel}>
            Peru
          </button>
          <button className="btn btn-danger" onClick={onConfirm}>
            Poista
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmation;
